"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const AccountItem_1 = __importDefault(require("./AccountItem"));
const Formatter_1 = __importDefault(require("../../Formatter"));
const MonthSnapshot_1 = __importDefault(require("./MonthSnapshot"));
class Month {
    constructor(data) {
        this.id = null; //TODO: this is a hack
        this.date = '';
        this.is_forecast = false;
        this.account_items = [];
        this.snapshots = [];
        for (let key in data) {
            if (this.hasOwnProperty(key)) {
                this[key] = data[key];
            }
        }
        this.account_items = this.account_items.map(item => new AccountItem_1.default(item));
        this.snapshots = this.snapshots.map(item => new MonthSnapshot_1.default(item));
    }
    /**
     * @deprecated
     */
    get ForecastSummary() {
        return null;
    }
    get AccountItems() {
        return this.account_items.map(item => new AccountItem_1.default(item));
    }
    get Date() {
        return Formatter_1.default.serverDateFormatToMoment(this.date);
    }
    /**
     * @deprecated
     */
    get AspirationAmount() {
        return null;
    }
    /**
     * @deprecated
     */
    set AspirationAmount(value) { }
    /**
     * @deprecated
     */
    get AspirationFormula() {
        return null;
    }
    /**
     * @deprecated
     */
    set AspirationFormula(value) { }
    /**
     * @deprecated
     */
    accountItemByAccountNumber() {
        return null;
    }
    /**
     * @deprecated
     */
    get AspirationPercentage() {
        return 0;
    }
    /**
     * @deprecated
     */
    get AspirationFormulaType() {
        return null;
    }
}
module.exports = Month;
